import axios from 'redaxios';
require('dotenv').config({ path: `.env` });
const apiUrl = process.env.REACT_APP_API_URL;

export const useConnectUser = (publicKey) => {
  return axios.get(`${apiUrl}/connect-user/${publicKey}`).catch((err) => {
    console.log('server err');
  });
};
